var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#F6C054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0874 8.75708L9.24299 2.9127C9.21127 2.88087 9.17357 2.8556 9.13207 2.83837C9.09056 2.82113 9.04606 2.81226 9.00112 2.81226C8.95617 2.81226 8.91167 2.82113 8.87016 2.83837C8.82866 2.8556 8.79096 2.88087 8.75924 2.9127L2.91374 8.75764C2.8819 8.78936 2.85664 8.82706 2.8394 8.86856C2.82217 8.91007 2.81329 8.95457 2.81329 8.99952C2.81329 9.04446 2.82217 9.08896 2.8394 9.13047C2.85664 9.17197 2.8819 9.20967 2.91374 9.24139L8.75812 15.0875C8.78983 15.1192 8.82749 15.1444 8.86894 15.1616C8.9104 15.1788 8.95483 15.1876 8.99971 15.1876C9.04459 15.1876 9.08902 15.1788 9.13048 15.1616C9.17193 15.1444 9.20959 15.1192 9.2413 15.0875L15.0857 9.24364C15.1179 9.21199 15.1436 9.17426 15.1612 9.13263C15.1788 9.091 15.1879 9.0463 15.1881 9.00111C15.1884 8.95592 15.1796 8.91113 15.1624 8.86934C15.1452 8.82756 15.1199 8.78959 15.0879 8.75764L15.0874 8.75708ZM13.8026 9.04958L9.51862 13.3336V9.00008H8.47912V13.3336L4.19512 9.04958C4.18865 9.04329 4.18352 9.03577 4.18001 9.02746C4.1765 9.01915 4.17469 9.01022 4.17469 9.0012C4.17469 8.99219 4.1765 8.98326 4.18001 8.97495C4.18352 8.96664 4.18865 8.95912 4.19512 8.95283L8.95049 4.19802C8.95678 4.19155 8.9643 4.18642 8.97261 4.18291C8.98092 4.1794 8.98985 4.17759 8.99887 4.17759C9.00789 4.17759 9.01681 4.1794 9.02512 4.18291C9.03343 4.18642 9.04095 4.19155 9.04724 4.19802L13.8026 8.95283C13.8091 8.95912 13.8142 8.96664 13.8177 8.97495C13.8212 8.98326 13.823 8.99219 13.823 9.0012C13.823 9.01022 13.8212 9.01915 13.8177 9.02746C13.8142 9.03577 13.8091 9.04329 13.8026 9.04958C13.8026 9.04733 13.8026 9.04733 13.8026 9.04958Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmb);
export default __webpack_public_path__ + "static/media/emb.983b0d788b0ea32126888447a9df9dce.svg";
export { ForwardRef as ReactComponent };